if (!window.Maximize.loadedScript.includes('variant-picker.js')) {
  window.Maximize.loadedScript.push("variant-picker.js");

  class VariantPicker extends HTMLElement {
    static cacheData = {};
    constructor() {
      super();
      this.pickerType = this.dataset.pickerType || 'swatch';
      this.productId = this.dataset.productId;
      this.sectionId = this.dataset.sectionId;
      this.productUrl = this.dataset.url;
      this.isMainProduct = this.dataset.mainProduct === 'true';
      this.optionElements = this.querySelectorAll(`.variant-option`);
      this.optionLabelElements = Array.from(this.querySelectorAll(`.variant-option__label`));
      this.optionsSelectedValues = [];
      this.isEnableStickyATC = this.dataset.enableStickyAtc === 'true';
      this.currentVariantInfoElement = document.querySelector(`#CurrentVariantInfo__${this.sectionId}`);
      this.addtionalCurrentVariantInfoElement = document.querySelector(`#AdditionalVariantInfo__${this.sectionId}`);
      this.currentVariant = JSON.parse(this.currentVariantInfoElement.textContent);
      this.sectionWrapper = document.getElementById(`shopify-section-${this.sectionId}`);
      this.specSectionElement = document.querySelectorAll(`.product-specifications-${this.productId}`);
      this.productDetailsElement = document.querySelector('product-details');
      this.tabSectionElement = document.querySelectorAll('.tabs-section');
      if (this.specSectionElement && this.isMainProduct) {
        this.specSectionIds = Array.from(this.specSectionElement).map(el => el.dataset.sectionId);
      }
      if (this.productDetailsElement && this.isMainProduct) {
        this.productDetailSectionId = this.productDetailsElement.dataset.sectionId;
      }
      if (this.tabSectionElement && this.isMainProduct) {
         this.tabSectionIds = Array.from(this.tabSectionElement).map(el => el.dataset.sectionId);
      }

      if (this.currentVariant) {
        this.isOptionExist = true;
        this.isOptionAvailable = this.currentVariant.available;
      } else {
        this.isOptionExist = false;
      }
    }

    connectedCallback() {
      this.optionElements.forEach(el => {
        el.addEventListener('click', this.handleChangedOption.bind(this));
      })

      this.optionLabelElements.forEach(el => {
        el.addEventListener('keyup', el => {
          if (el.key === 'Enter' || el.key === ' ') {
            let optionInput = el.target.previousElementSibling;
            optionInput.click();
          }
        })
      })

      if (Shopify.designMode) {
        window.addEventListener('shopify:section:load', (event) => {
          if (event.detail.sectionId == this.sectionId) {
            VariantPicker.cacheData = {};
          };
        });
      }

      this.updateOptionSelectedValues();
      this.modelChoice = window.ShamosModelChoice?.attach(this);
      const needsModelResolve = this.modelChoice?.initialize();
      if (needsModelResolve || (!this.modelChoice && this.__normalizeConstrainedVariantOptions())) {
        this.__renderProductInfo();
      }

      this.__updateConstrainedVariantAvailability();
      this.modelChoice?.sync();

      if (this.isEnableStickyATC) {
        this.__initEventSticky();
      }
    }

    disconnectedCallback() {
      this.modelChoice?.destroy();
    }

    handleChangedOption(event) {
      const targetOption = event.currentTarget;
      if (this.modelChoice && !this.modelChoice.choose(targetOption)) return;
      let position = targetOption.dataset.optionPosition;
      let listOptionSamePosition = this.querySelectorAll(`.variant-option[data-option-position='${position}']`);
      listOptionSamePosition.forEach(optionEle => {
        optionEle.classList[optionEle === targetOption ? 'add' : 'remove']('selected');
        optionEle.setAttribute("aria-selected", String(optionEle === targetOption));
      });
      const selectedOptionEle = this.querySelector(`.variant-option__selected-value[data-position='${position}']`);
      if (selectedOptionEle) {
        selectedOptionEle.innerHTML = targetOption.dataset.value;
      }

      this.updateOptionSelectedValues();
      this.__renderProductInfo();
    }

    updateOptionSelectedValues() {
      this.optionElements.forEach((optionEle) => {
        const optionPosition = optionEle.dataset.optionPosition;
        const idx = Number(optionPosition) - 1;
        if (optionEle.classList.contains('selected')) {
          this.optionsSelectedValues[idx] = optionEle.dataset.optionValueId;
        }
      });
    }

    __getConstrainedVariants() {
      const variantData = this.querySelector('script[data-constrained-variants]');
      if (!variantData) return null;
      let data;
      try {
        data = JSON.parse(variantData.textContent);
      } catch {
        return null;
      }
      if (Array.isArray(data)) return data;
      if (!data || !Array.isArray(data.options) || !Array.isArray(data.available) ||
        data.options.length !== data.count || data.available.length !== data.count ||
        data.count < 1 || data.count > 250 || data.options.some(options =>
          !Array.isArray(options) || options.length < 1 || options.length > 3 ||
          options.some(value => typeof value !== 'string'))) return null;
      return data.options.map((options, index) => ({ options, available: data.available[index] }));
    }

    __normalizeConstrainedVariantOptions() {
      const variants = this.__getConstrainedVariants();
      if (!Array.isArray(variants) || !variants.length) return false;
      const optionElements = Array.from(this.optionElements);
      const selectedValues = this.optionsSelectedValues.map((id, index) => {
        const option = optionElements.find(element =>
          Number(element.dataset.optionPosition) === index + 1 &&
          element.dataset.optionValueId === String(id)
        );
        return option?.dataset.value;
      });
      if (selectedValues.some(value => value === undefined)) return false;
      if (variants.some(variant => Array.isArray(variant.options) &&
        variant.options.length === selectedValues.length &&
        variant.options.every((value, index) => value === selectedValues[index]))) {
        return false;
      }
      let replacement;
      for (let prefixLength = selectedValues.length - 1; prefixLength >= 1; prefixLength--) {
        const matchingPrefix = variants.filter(variant =>
          Array.isArray(variant.options) &&
          variant.options.length === selectedValues.length &&
          selectedValues.slice(0, prefixLength).every((value, index) => variant.options[index] === value)
        );
        if (matchingPrefix.length) {
          replacement = matchingPrefix.find(variant => variant.available) || matchingPrefix[0];
          break;
        }
      }
      if (!replacement) return false;
      const replacementElements = replacement.options.map((value, index) =>
        optionElements.find(element =>
          Number(element.dataset.optionPosition) === index + 1 &&
          element.dataset.value === value
        )
      );
      if (replacementElements.some(element => !element)) return false;
      replacementElements.forEach((selectedElement, index) => {
        const position = String(index + 1);
        this.optionsSelectedValues[index] = selectedElement.dataset.optionValueId;
        optionElements.filter(element => element.dataset.optionPosition === position).forEach(element => {
          const selected = element === selectedElement;
          element.classList.toggle('selected', selected);
          element.setAttribute('aria-selected', String(selected));
          if (element.matches('input')) element.checked = selected;
        });
        const label = this.querySelector(`.variant-option__selected-value[data-position='${position}']`);
        if (label) label.textContent = selectedElement.dataset.value;
        const dropdownLabel = this.querySelector(`.variant-option__select-button__label[data-option-position='${position}']`);
        if (dropdownLabel) dropdownLabel.textContent = selectedElement.dataset.value;
        const dropdownInput = this.querySelector(`select-element[data-option-position='${position}'] .select-option-selected`);
        if (dropdownInput) dropdownInput.value = selectedElement.dataset.value;
      });
      return true;
    }

    __updateConstrainedVariantAvailability() {
      const variants = this.__getConstrainedVariants();
      if (!Array.isArray(variants) || !variants.length) return;
      const selectedValues = this.optionsSelectedValues.map((id, index) => {
        const option = Array.from(this.optionElements).find(element =>
          Number(element.dataset.optionPosition) === index + 1 &&
          element.dataset.optionValueId === String(id)
        );
        return option?.dataset.value;
      });
      if (!selectedValues.length || selectedValues.some(value => value === undefined)) return;
      this.constrainedOptionPresentation ||= new WeakMap();
      const scopes = [this];
      const sticky = document.getElementById(`StickyAddToCart__Variant__${this.sectionId}`);
      if (sticky) scopes.push(sticky);
      scopes.forEach(scope => {
        scope.querySelectorAll('.variant-option').forEach(option => {
          const index = Number(option.dataset.optionPosition) - 1;
          if (index < 1) return;
          const exists = variants.some(variant => Array.isArray(variant.options) &&
            variant.options[index] === option.dataset.value &&
            selectedValues.slice(0, index).every((value, previous) => variant.options[previous] === value)
          );
          const elements = [option, ...scope.querySelectorAll(`.variant-option__label[data-option-value-id='${option.dataset.optionValueId}']`)];
          elements.forEach(element => {
            if (!this.constrainedOptionPresentation.has(element)) {
              this.constrainedOptionPresentation.set(element, {
                tabindex: element.getAttribute('tabindex'),
                display: element.style.getPropertyValue('display'),
                displayPriority: element.style.getPropertyPriority('display')
              });
            }
            const original = this.constrainedOptionPresentation.get(element);
            element.dataset.variantNonexistent = String(!exists);
            element.hidden = !exists;
            element.toggleAttribute('inert', !exists);
            if (exists) {
              element.removeAttribute('aria-hidden');
              if (original.tabindex === null) element.removeAttribute('tabindex');
              else element.setAttribute('tabindex', original.tabindex);
              if (original.display) element.style.setProperty('display', original.display, original.displayPriority);
              else element.style.removeProperty('display');
            } else {
              element.setAttribute('aria-hidden', 'true');
              element.setAttribute('tabindex', '-1');
              element.style.setProperty('display', 'none', 'important');
            }
          });
        });
      });
    }

    async __renderProductInfo() {
      this.modelChoice?.begin();
      const renderVersion = (this.renderVersion || 0) + 1;
      this.renderVersion = renderVersion;
      // Navigation observers must stop exposing the previous accessory selection before any await.
      if (!this.modelChoice) this.dispatchEvent(new CustomEvent('shamos:variant-render-pending:' + this.sectionId, {
        bubbles: true,
        detail: { productId: this.productId, sectionId: this.sectionId, renderVersion }
      }));
      if (this.__normalizeConstrainedVariantOptions()) {
        await new Promise(resolve => requestAnimationFrame(resolve));
      }
      this.__updateConstrainedVariantAvailability();
      const buyButtonList = this.sectionWrapper.querySelectorAll(".product-info__buy-buttons-wrapper button, .block-add-to-cart__button");
      buyButtonList.forEach(button => {
        button.disabled = true
      });
      const url = `${this.productUrl}?option_values=${this.optionsSelectedValues.join(',')}&sections=${this.sectionId},${(this.specSectionIds || []).join(',')},${this.productDetailSectionId || ''},${(this.tabSectionIds || []).join(',')}`;
      let productResponseHTML = VariantPicker.cacheData[url];
      if (!productResponseHTML) {
        try {
          const response = await fetch(url);
          const contentType = response.headers.get('content-type');
        
        if (contentType && contentType.includes('application/json')) {
          const sectionsData = await response.json();
          const parsedSections = {};
          for (const [sectionKey, sectionHtml] of Object.entries(sectionsData)) {
            parsedSections[sectionKey] = new DOMParser().parseFromString(sectionHtml, "text/html");
          }
          
          productResponseHTML = parsedSections;
        } else {
          const text = await response.text();
          productResponseHTML = {
            [this.sectionId]: new DOMParser().parseFromString(text, "text/html")
          };
        }
         VariantPicker.cacheData[url] = productResponseHTML;
        } catch (error) {
          console.error(error)
        }
      }

      if (renderVersion !== this.renderVersion) return;

      if (!productResponseHTML || !productResponseHTML[this.sectionId]) {
        this.modelChoice?.fail('We could not load that selection. Please choose your phone model again.');
        return;
      }
      const productInfoHTML = productResponseHTML[this.sectionId];
      // Verify response ownership before any section, variant or controller mutation.
      // Shopify variant JSON is not guaranteed to include product_id.
      const newVariantPickerEle = productInfoHTML.querySelector(`.section--${this.sectionId} variant-picker.variant-picker__wrapper`);
      if (!newVariantPickerEle || String(newVariantPickerEle.dataset.productId) !== String(this.productId)) {
        this.modelChoice?.fail('We could not confirm this product selection. Please choose your phone model again.');
        return;
      }
      if (this.modelChoice) {
        const resolvedInfo = productInfoHTML.querySelector(`#CurrentVariantInfo__${this.sectionId}`);
        try {
          if (!resolvedInfo || !JSON.parse(resolvedInfo.textContent)) throw new Error('Unresolved variant');
        } catch (_) {
          this.modelChoice.fail('That model and finish are not available together. Please choose another option.');
          return;
        }
      }
      const productDetailInfoHTML = productResponseHTML[this.productDetailSectionId];
      if (productResponseHTML) {
        if (this.specSectionIds?.length > 0) {
          this.__updateSpecificationContent(this.specSectionIds, productResponseHTML, ".spec-col-content");
        }
        if (this.tabSectionIds?.length > 0) {
          this.__updateSpecificationContent(this.tabSectionIds, productResponseHTML, ".tabs__content__specification");
        }
      }
      if (productDetailInfoHTML) {
        this.__updateProductDetailSpecifications(productDetailInfoHTML);
      }

      this.dataset.currentVariantId = newVariantPickerEle?.dataset.currentVariantId || '';
      const variantId = this.dataset.currentVariantId;

      if (this.isMainProduct && !this.modelChoice) {
        if (variantId.length > 0){
          window.history.replaceState({}, "", `${this.productUrl}?variant=${variantId}`);
        } else {
          window.history.replaceState({}, "", `${this.productUrl}`);
        }
      }

      this.__updateCurrentVariantInfo(productInfoHTML);
      this.modelChoice?.accept(this.currentVariant);
      this.modelChoice?.updateURL();

      if (this.currentVariant) {
        const selectors = [
          ".product-info__label-wrapper", // update labels
          ".product-template__properties", // update properties of the product
          ".product-info__volume-pricing"
        ];

        const selectorsUpdateWhenAvailable = [
          '.product-info__estimate-delivery-wrapper',
          '.product-info__rating',
          '.product-info__label-wrapper',
          '.product-form__dynamic-checkout',
          `#PickupAvailability__${this.sectionId}`
        ]

        selectors.forEach(selector => {
          this.__updateElements(productInfoHTML, selector);
        });

        const blockSelectors = [
          ".product-info__estimate-delivery-wrapper",
          ".product-info__price-wrapper", // update price
          ".product-info__identifier-wrapper", // update sku, barcode
          ".product-info__inventory-status-wrapper",
          ".product-info__back-in-stock-alert-wrapper",
          ".product-info__quantity-wrapper"
        ];

        blockSelectors.forEach(selector => {
          this.__updateBlockElements(productInfoHTML, selector);
        });

        this.__updateTableOfInformation(productInfoHTML)

        selectorsUpdateWhenAvailable.forEach(selector => {
          const element = document.querySelector(`.section--${this.sectionId} ${selector}`);
          if (element) {
            element.classList.remove('is-unavailable');
          }
        })
      } else {
        this.__renderProductInfoWhenUnavailable();
      }

      this.__updateVariantPickerWhenChange(productInfoHTML);

      // Suppress Safari's spurious ::before transition on ALL buttons BEFORE any re-enable or event dispatch.
      // Safari recreates the ::before pseudo-element whenever the button transitions from disabled/aria-disabled
      // to enabled (because :not([disabled]):not([aria-disabled="true"])::before starts matching again),
      // and plays a transition from transform:none → scale(0) — visually: a circle appears then shrinks.
      //
      // TWO cases must be covered:
      // (a) available → available: button.disabled toggles here → handled by the loop below
      // (b) unavailable → available: button has aria-disabled="true" (set by Alpine), so it is SKIPPED
      //     in the loop below, but Alpine removes aria-disabled in a microtask triggered by
      //     __dispatchChangeVariantEvent. The class must already be on the button at that moment.
      //
      // Timeline:
      //   [sync]     add is-variant-changing to ALL buttons
      //   [sync]     re-enable non-aria-disabled buttons (case a)
      //   [sync]     __dispatchChangeVariantEvent → Alpine microtask queued
      //   [microtask] Alpine removes aria-disabled → ::before created → transition: none ✅ (case b)
      //   [rAF 1]    first frame
      //   [rAF 2]    remove is-variant-changing → transitions restored
      buyButtonList.forEach(button => {
        button.classList.add('is-variant-changing');
      });

      buyButtonList.forEach(button => {
        if (!button.ariaDisabled && (!this.modelChoice || this.modelChoice.state === 'ready')) {
          button.disabled = false;
        }
      });

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          buyButtonList.forEach(button => {
            button.classList.remove('is-variant-changing');
          });
        });
      });

      this.siblingSettledRenderVersion = renderVersion;
      this.__dispatchChangeVariantEvent(productInfoHTML, renderVersion);

      if (this.isEnableStickyATC) {
        this.__renderStickyATC(productInfoHTML);
      }
      this.__updateConstrainedVariantAvailability();
      this.modelChoice?.sync();
    }

    __updateElements(productInfoHTML, selector) {
      const oldElement = document.querySelector(`.section--${this.sectionId} ${selector}`);
      const newElement = productInfoHTML.querySelector(`.section--${this.sectionId} ${selector}`);
      if (oldElement && newElement) {
        oldElement.innerHTML = newElement.innerHTML;
        if (oldElement.classList.contains('is-unavailable')) {
          oldElement.classList.remove('is-unavailable');
        }
      }
    }

    __updateBlockElements(productInfoHTML, selector) {
      const oldElements = document.querySelectorAll(`.section--${this.sectionId} ${selector}`);
      oldElements.forEach(oldEl => {
        const blockId = oldEl.dataset.blockId;
        const newEl = productInfoHTML.querySelector(
          `.section--${this.sectionId} ${selector}[data-block-id="${blockId}"]`
        );
        if (oldEl && newEl) {
          oldEl.innerHTML = newEl.innerHTML;
          oldEl.classList.remove('is-unavailable');
        }
      });
    }

    __updateTableOfInformation(productInfoHTML) {
      const selector = ".table-content__row__last";
      const oldElements = document.querySelectorAll(`.section--${this.sectionId} ${selector}`);
      const newElements = productInfoHTML.querySelectorAll(`.section--${this.sectionId} ${selector}`);
      oldElements.forEach((oldEle, index) => {
        if (newElements[index]) {
          oldEle.innerHTML = newElements[index].innerHTML;
        }
      });
    }

    __updateProductDetailSpecifications(productDetailInfoHTML) {
      const selector = ".product-details__specifications__content";
      const oldElements = document.querySelectorAll(`.section--${this.productDetailSectionId} ${selector}`);
      const newElements = productDetailInfoHTML.querySelectorAll(`.section--${this.productDetailSectionId} ${selector}`);
      oldElements.forEach((oldEle, index) => {
        if (newElements[index]) {
          oldEle.innerHTML = newElements[index].innerHTML;
        }
      });
    }
 
    __updateSpecificationContent(specSectionIds,productResponseHTML, selector) {
      specSectionIds.forEach(sectionId => {
        const sectionElement = productResponseHTML[sectionId];
        if (!sectionElement) return; 

        const oldElements = document.querySelectorAll(`.section--${sectionId} ${selector}`);
        const newElements = sectionElement.querySelectorAll(`.section--${sectionId} ${selector}`);

        oldElements.forEach((oldEle, index) => {
          if (newElements[index]) {
            oldEle.innerHTML = newElements[index].innerHTML;
          }
        });
      });
    }

    __updateVariantPickerWhenChange(productInfoHTML) {
      this.optionElements.forEach(el => {
        const optionValueId = el.dataset.optionValueId;
        const newOptionEle = productInfoHTML.querySelector(`variant-picker.variant-picker__wrapper .variant-option[data-option-value-id="${optionValueId}"]`);
        if (newOptionEle) {
          el.classList[newOptionEle.classList.contains('disabled') ? 'add' : 'remove']('disabled');
          el.classList[newOptionEle.classList.contains('selected') ? 'add' : 'remove']('selected');
          el.checked = newOptionEle.classList.contains('selected');

          el.innerHTML = newOptionEle.innerHTML;
          el.dataset.selectValue = newOptionEle.dataset.selectValue;
        }
      })

      this.optionLabelElements.forEach(el => {
        const optionValueId = el.dataset.optionValueId;
        const newOptionEle = productInfoHTML.querySelector(`variant-picker.variant-picker__wrapper .variant-option__label[data-option-value-id="${optionValueId}"]`);
        if (newOptionEle) {
          el.classList[newOptionEle.classList.contains('disabled') ? 'add' : 'remove']('disabled');
          el.classList[newOptionEle.classList.contains('selected') ? 'add' : 'remove']('selected');
        }
      })

      // fix for the dropdown type
      const listSelectElementLabels = this.querySelectorAll(`.select-button__label.variant-option__select-button__label`);
      listSelectElementLabels.forEach(el => {
        const position = el.dataset.optionPosition;
        const newEl = productInfoHTML.querySelector(`variant-picker.variant-picker__wrapper .select-button__label.variant-option__select-button__label[data-option-position="${position}"]`);
        if (newEl) {
          el.innerHTML = newEl.innerHTML.trim();
        }
      })

      const oldListSwatch = document.querySelectorAll(`.section--${this.sectionId} .swatch-option__label`);
      if (oldListSwatch.length > 0) {
        oldListSwatch.forEach((swatch) => {
          const optionId = swatch.getAttribute('for');

          const newSwatchLabel = productInfoHTML.querySelector(`.swatch-option__label[for=${optionId}]`)

          if (newSwatchLabel) {
            if (newSwatchLabel.dataset.swatchStyle === 'image') {
              swatch.style.setProperty('--swatch-image-value', newSwatchLabel.dataset.swatchValue);
            } else if (newSwatchLabel.dataset.swatchStyle === 'color') {
              swatch.style.setProperty('--swatch-color-value', newSwatchLabel.dataset.swatchValue);
            }
          }
        });
      }
    }

    __renderStickyATC (productInfoHTML) {
      const selectors = [
        `#StickyAddToCart__Image__${this.sectionId}`,
        `#StickyAddToCart__Variant__${this.sectionId}`,
        `#StickyAddToCart__Price__${this.sectionId}`,
        `.sticky-add-to-cart__form`
      ];

      selectors.forEach(selector => {
        this.__updateElements(productInfoHTML, selector);
      });
    }

    __initEventSticky() {
      document.addEventListener(`${STICKY_ATC_EVENT.optionChange}-${this.sectionId}`, (event) => {
        if (event.detail.optionsSelectedValues) {
          const values = event.detail.optionsSelectedValues.slice();
          if (this.modelChoice) {
            const changedPosition = Number(event.detail.optionPosition);
            if (!Number.isInteger(changedPosition) || changedPosition < 1 || changedPosition > values.length) return;
            const modelPosition = this.modelChoice.config.modelPosition;
            // A finish click must retain the main picker's verified model even
            // if a detached sticky selection array still contains an older ID.
            if (changedPosition !== modelPosition) {
              const intendedModelId = this.modelChoice.wanted?.optionId;
              if (!intendedModelId) return;
              values[modelPosition - 1] = intendedModelId;
            }
            if (!this.modelChoice.chooseValues(values)) return;
          }
          this.optionsSelectedValues = values;
          this.__renderProductInfo();
        }
      })
    }

    __updateCurrentVariantInfo(productInfoHTML) {
      const newCurrentVariantInfoElement = productInfoHTML.querySelector(`#CurrentVariantInfo__${this.sectionId}`);
      if (newCurrentVariantInfoElement) {
        this.currentVariantInfoElement.textContent = newCurrentVariantInfoElement.textContent;
        this.currentVariant = JSON.parse(newCurrentVariantInfoElement.textContent);
      }

      const newAdditionalCurrentVariantInfoElement = productInfoHTML.querySelector(`#AdditionalVariantInfo__${this.sectionId}`);
      if (newAdditionalCurrentVariantInfoElement) {
        this.addtionalCurrentVariantInfoElement.textContent = newAdditionalCurrentVariantInfoElement.textContent;
      }

      if (this.currentVariant) {
        this.isOptionExist = true;
        this.isOptionAvailable = this.currentVariant.available;
      } else {
        this.isOptionExist = false;
      }
    }

    __renderProductInfoWhenUnavailable() {
      const selectors = [
        // ".product-info__variant-picker", // update price
        ".product-info__price-wrapper", // update price
        ".product-info__identifier-wrapper", // update sku, barcode
        ".product-info__estimate-delivery-wrapper", // update estimate delivery
        ".product-info__label-wrapper", // update labels
        ".product-info__inventory-status-wrapper", // update inventory status
        ".product-info__rating", // update rating
        `#PickupAvailability__${this.sectionId}`,
        ".product-info__volume-pricing"
      ];

      selectors.forEach(selector => {
        const element = document.querySelector(`.section--${this.sectionId} ${selector}`);
        if (element) {
          element.classList.add('is-unavailable');
        }
      });
    }

    __dispatchChangeVariantEvent(updatedHTML, renderVersion) {
      document.dispatchEvent(
        new CustomEvent(`${PRODUCT_EVENT.updatedVariant}${this.sectionId}`, {
          bubbles: true,
          detail: {
            productId: this.productId,
            renderVersion: renderVersion,
            currentVariant: this.currentVariant,
            sectionId: this.sectionId,
            isOptionAvailable: this.isOptionAvailable,
            isOptionExist: this.isOptionExist,
            previewMediaId: this.dataset.mediaId,
            optionsSelectedValues: this.optionsSelectedValues,
            updatedHTML: updatedHTML
          },
        })
      );
    }
  }

  if (!customElements.get('variant-picker')) {
    customElements.define('variant-picker', VariantPicker);
  }
}
